import { initFilters } from './modules/filtering';
document.addEventListener('DOMContentLoaded', function () {
  initFilters();
});